import { render, staticRenderFns } from "./RDCAlertEvent.vue?vue&type=template&id=0d169612"
import script from "./RDCAlertEvent.vue?vue&type=script&lang=js"
export * from "./RDCAlertEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports